import { IAxiosResponse } from '../store/ducks/root.types'
import axiosInstance from './axios'
import { Ngo } from '../store/application/models/ngo/ngo'

class NgoService {

  constructor(private apiVersion: string = 'v1') { }

  /**
   * Returns all NGO data
   * @returns {NGO} NGO data
   * @returns {any} headers
   */
  public async get(): Promise<IAxiosResponse<Ngo>> {
    return axiosInstance
      .get(`${this.apiVersion}/ong`)
      .then((response) => {
        return {
          data: new Ngo().fromJSON(response.data[0]),
          headers: response.headers
        }
      })
  }
  /**
   * NGO data by ID
   * @returns {NGO} NGO data
   * @returns {any} headers
   */
  public async getById(ngoId: string): Promise<IAxiosResponse<any>> {
    return axiosInstance
      .get(`${this.apiVersion}/ong/${ngoId}`)
      .then((response) => {
        return {
          data: new Ngo().fromJSON(response.data),
          headers: response.headers
        }
      })
  }
  /**
   * creates the data of an NGO
   * @param {NGO} newNgo data from a new NGO
   * @returns {NGO} NGO data
   * @returns {any} headers 
   */
  public async create(newNgo: Ngo): Promise<IAxiosResponse<Ngo>> {
    return axiosInstance
      .post(`${this.apiVersion}/ong`, newNgo)
      .then((response) => {
        return {
          data: new Ngo().fromJSON(response.data),
          headers: response.headers
        }
      })
  }
   /**
    * Update the data of an NGO
    * @param {NGO} newData data from a NGO
    * @returns {NGO} NGO data
    * @returns {any} headers 
    */
  public async updade(newData: Ngo): Promise<IAxiosResponse<Ngo>> {
    return axiosInstance
      .patch(`${this.apiVersion}/ong/${newData.id}`,
        { ...newData.toJSON() })
      .then((response) => {
        return {
          data: new Ngo().fromJSON(response.data),
          headers: response.headers
        }
      })
  }

}
const ngoService = new NgoService()

export default ngoService